module.exports = __webpack_public_path__ + "img/max-envelope-edit.cf14b4b9.svg";